import { i18n } from 'i18n'

export function getGenderTitle(gender: string) {
  if (!gender) return i18n('demo.GenderAll')
  if (gender === 'female') return i18n('demo.Female')
  if (gender === 'male') return i18n('demo.Male')
  if (gender === 'unisex') return i18n('demo.Unisex')
  if (gender === 'none') return i18n('demo.GenderNone')
  return gender.toUpperCase()
}
